







































import { Component, Vue, Prop } from "vue-property-decorator";
import store from "@/store";

@Component
export default class LoginForm extends Vue {
  @Prop() public dismissModal: any;

  public formUsername: string = "";
  public formPassword: string = "";

  public get username(): string {
    return this.formUsername;
  }

  public set username(value: string) {
    this.formUsername = value;
  }

  public get password(): string {
    return this.formPassword;
  }

  public set password(value: string) {
    this.formPassword = value;
  }

  public login() {
    if (!this.$validator.errors.items.length) {
      store.dispatch("requestAuthToken", {
        username: this.username,
        password: this.password,
        app: this
      });
    }
  }

  public handleLoginStatusMessage(issue: any) {
    if (issue) {
      return this.$ionic.alertController
        .create({
          header: "Login fehlgeschlagen",
          message: "Benutzername oder Passwort waren nicht korrekt.",
          buttons: ["OK"]
        })
        .then(a => a.present());
    } else {
      this.dismissModal();
    }
  }
}
